import React, { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Drag } from "@dms/components/DragAndDrop/Drag";
import { HolderOutlined } from "@ant-design/icons";
import { GQL } from "@binale-tech/shared";

export const CellRendererDragComponent: FC<ICellRendererParams<GQL.IDocument>> = ({ data }) => {
    if (!data) {
        return null;
    }
    return (
        <Drag id={data.key} typeDrag="list">
            <HolderOutlined />
        </Drag>
    );
};
